<template>
  <div class="Pagelogin">
    <arrowLeft style="margin-left: -8px"></arrowLeft>
    <div class="login">
      <div class="login-left">欢迎登录</div>
      <div class="login-right" @click="$router.push('/register')">
        点击去注册>
      </div>
    </div>
    <div style="margin-top: 24px">
      <van-form @submit="onsubmit">
        <van-field
          v-model="account"
          name="account"
          type="tel"
          placeholder="请输入手机号"
          style="background: #f5f5f5; font-size: 15px"
          :rules="[{ required: true }]"
          maxlength="11"
        />
        <van-field
          v-model="password"
          type="password"
          name="password"
          placeholder="请输入您的登录密码"
          :rules="[{ required: true }]"
          style="background: #f5f5f5; margin-top: 8px; font-size: 15px"
        />
        <div style="margin-top: 24px">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            style="background: #224a91; border-radius: 4px"
            >马上登录</van-button
          >
        </div>
      </van-form>
      <div class="forget" @click="$router.push('/forget')">忘记密码</div>
    </div>
    <logo></logo>
  </div>
</template>

<script>
import arrowLeft from "@/components/arrow-left";
import logo from "@/components/logo";
import { userLogin } from "../service/api";
import { base64_encode, authcode} from "@/utils/md5";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "login",
  data() {
    return {
      account: "",
      password: "",
    };
  },
  components: {
    arrowLeft,
    logo,
  },
  methods: {
    onsubmit(val) {
      if (val.account.length < 11) {
        this.$toast("手机号不足11位");
      } else {
        console.log('sumbit:',val)
        let params=val
        params.password=base64_encode(authcode(params.password,'ENCODE',"ertongyiyuan20240305"));

        userLogin(params)
          .then((res) => {
            if (res.code === 0) {
              localStorage.setItem("wa-token", res.data.token);
              this.$toast("登录成功!");
              this.$router.push("/index");
            } else {
              this.$toast("登录异常!");
            }
          })
          .catch((err) => {
            this.$toast(err.message);
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.Pagelogin {
  padding: 24px;
  background: #fefffe;
  .login {
    margin-top: 36px;
    display: flex;
    justify-content: space - between;
    .login-left {
      height: 32px;
      font-weight: 600;
      font-size: 24px;
    }
    .login-right {
      font-weight: 400;
      padding-top: 5px;
      text-decoration: underline;
      align-self: flex-end;
      font-size: 15px;
      color: #224a91;
    }
  }
  .forget {
    width: 80px;
    margin: 20px auto;
    text-align: center;
    text-decoration: underline;
    font-size: 15px;
    color: #224a91;
  }
}
</style>